<template>
  <VCard class="payment-wrapper" :color="ColorType.white">
    <VSection
      class="payment-price-wrapper"
      title="결제금액"
      :padding="[25, 15, 5, 15]"
      :useUnderline="false"
    >
      <VBlock
        class="payment-price"
        :direction="Direction.column"
        :sort="Sort.left_center"
        :padding="[15, 15, 0, 15]"
      >
        <VBlock :direction="Direction.column">
          <VBlock :sort="Sort.space_between" :margin="[0, 0, 15, 0]">
            <VSpan text="주문금액" :size="14" :color="TextColor.darkGray" :spacing="-0.33" />
            <VSpan
              :text="`${price.orderPrice}원`"
              :size="14"
              :color="TextColor.darkGray"
              :spacing="-0.33"
              :type="TextType.Number"
            />
          </VBlock>
          <VBlock v-if="selectedGiftCardsExist" :sort="Sort.space_between" class="giftcard-wrapper">
            <VSpan
              class="delivery-tip-text"
              text="상품권"
              :size="14"
              :color="TextColor.darkGray"
              :spacing="-0.33"
            />
            <VBlock :sort="Sort.right_center">
              <VSpan
                :text="`-${selectedGiftCardsPrice}원`"
                :color="TextColor.darkGray"
                :size="14"
                :type="TextType.Number"
                :spacing="-0.33"
              />
            </VBlock>
          </VBlock>
          <VBlock v-if="isShowDiscountAmount" :direction="Direction.column">
            <VBlock
              v-if="orderCouponPrice !== 0"
              :margin="[0, 0, 15, 0]"
              :sort="Sort.space_between"
            >
              <VSpan text="주문금액할인" :size="14" :color="TextColor.darkGray" :spacing="-0.33" />
              <VSpan
                :text="`-${orderCouponPrice}원`"
                :size="14"
                :color="TextColor.darkGray"
                :spacing="-0.33"
                :type="TextType.Number"
              />
            </VBlock>

            <VBlock
              v-if="deliveryCouponPrice !== 0"
              :margin="[0, 0, 15, 0]"
              :sort="Sort.space_between"
            >
              <VSpan text="배달팁할인" :size="14" :color="TextColor.darkGray" :spacing="-0.33" />
              <VSpan
                :text="`-${deliveryCouponPrice}원`"
                :size="14"
                :color="TextColor.darkGray"
                :spacing="-0.33"
                :type="TextType.Number"
              />
            </VBlock>
            <VBlock
              v-if="isShowBaeminPointDiscount"
              :margin="[0, 0, 15, 0]"
              :sort="Sort.space_between"
            >
              <VSpan text="배민포인트할인" :size="14" :color="TextColor.darkGray" :spacing="-0.33" />
              <VSpan
                :text="`-${baeminPointSpentAmount}원`"
                :size="14"
                :color="TextColor.darkGray"
                :spacing="-0.33"
                :type="TextType.Number"
              />
            </VBlock>
          </VBlock>

          <VBlock v-if="isShowDeliveryCharge" :sort="Sort.space_between">
            <VSpan
              class="delivery-tip-text"
              text="배달팁"
              :size="14"
              :color="TextColor.darkGray"
              :spacing="-0.33"
            />
            <VBlock class="delivery-tip-wrap" :sort="Sort.right_center">
              <del
                v-if="isProvideDeliveryTipDiscount && price.deliveryFee !== price.deliveryChargeBeforeDiscount"
                class="delivery-tip-discount-number"
              >
                <VSpan
                  :text="`${price.deliveryChargeBeforeDiscount}원`"
                  :color="TextColor.gray4"
                  :size="14"
                  :type="TextType.Number"
                  :spacing="-0.33"
                />
              </del>
              <VSpan
                :text="`${price.deliveryFee}원`"
                :size="14"
                :color="TextColor.darkGray"
                :spacing="-0.33"
                :type="TextType.Number"
              />
            </VBlock>
          </VBlock>
        </VBlock>
        <VBlock class="payment-price-text" :sort="Sort.space_between" :margin="[14, 0, 0, 0]">
          <VSpan
            text="총 결제금액"
            :weight="TextWeight.bold"
            :size="14"
            :color="TextColor.darkGray"
            :spacing="-0.33"
          />
          <span
            :style="{ fontSize: '22px', fontWeight: 'bold', textAlign: 'center', display: 'flex', letterSpacing: '-0.55px', color: '#222' }"
          >
            <div v-if="totalPaymentPrice !== 0">
              <IOdometer
                class="iOdometer"
                :style="{
              height: isAndroid ? '30px' : '26px',
              display: 'flex',
              alignItems: 'center',
              alignContents: 'center',
              fontSize: '22px',
              fontWeight: 'bold',
              textAlign: 'center',
              letterSpacing: '-0.55px',
              color: '#222',
              marginRight: '1px'
            }"
                :value="totalPaymentPrice"
                :duration="500"
              />
            </div>
            <span
              :style="{ height: isAndroid ? '30px' : '26px', display: 'flex', alignItems: 'center', alignContents: 'center' }"
              v-else
            >0</span>
            <span :style="{ height: '30px', display: 'inline-block' }">원</span>
          </span>
        </VBlock>
      </VBlock>
    </VSection>
  </VCard>
</template>

<script>
import VSpan, { TextColor, TextWeight, TextType } from '../../atoms/VSpan/index'
import VSection from '../../molecules/VSection/index'
import VBlock, { Direction, Sort } from '../../molecules/VBlock/index'
import VCard, { ColorType } from '../../molecules/VCard/index'

import Product from '@/models/Product/Product'
import IOdometer from 'vue-odometer'
import 'odometer/themes/odometer-theme-default.css'

import { isProvideDeliveryTipDiscount } from '../../../../../../config/featureProvider'

export default {
  name: 'PreOrderPayment',
  components: {
    VCard,
    VSpan,
    VSection,
    VBlock,
    IOdometer
  },
  props: {
    includeReturnOrExchangeProduct: {
      type: Boolean,
      required: true
    },
    price: {
      type: Object,
      required: true
    },
    cartDiscount: {
      type: Object,
      required: true
    },
    coupon: {
      type: Object,
      required: true
    },
    baeminPoint: {
      type: Object,
      required: true
    },
    totalPaymentPrice: {
      type: Number,
      required: true
    },
    onPaymentDetail: {
      type: Function,
      required: true
    },
    isProvideBaeminPoint: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      Direction,
      Sort,
      ColorType,
      TextWeight,
      TextType,
      TextColor
    }
  },
  mounted() {
    setTimeout(() => {
      this.value = this.totalPaymentPrice
    }, 10)
  },
  updated() {
    setTimeout(() => {
      this.value = this.totalPaymentPrice
    }, 500)
  },
  computed: {
    isProvideDeliveryTipDiscount() {
      return isProvideDeliveryTipDiscount
    },

    isAndroid() {
      return this.$store.getters.isAndroid
    },

    isShowDeliveryCharge() {
      return this.includeReturnOrExchangeProduct === false
    },

    isShowDiscountAmount() {
      return this.isSelectedCoupon || this.isShowBaeminPointDiscount
    },

    isSelectedCoupon() {
      return this.coupon.selected.length > 0
    },

    isShowBaeminPointDiscount() {
      return this.isProvideBaeminPoint && this.baeminPointSpentAmount > 0
    },
    selectedGiftCardsExist() {
      return this.$store.getters['preOrder/selectedGiftCards'].length > 0
    },
    selectedGiftCardsPrice() {
      return this.$store.getters['preOrder/selectedGiftCards']
        .reduce((prev, next) => prev + next.spentAmount, 0)
        .toLocaleString()
    },

    couponPrice() {
      function getCouponFilteredPrice(filteredProducts) {
        const filteredTotalitems = filteredProducts.reduce(
          (itemAcc, itemCur) => [...itemAcc, ...itemCur.items],
          []
        )
        const totalPrice = filteredTotalitems.reduce(
          (acc, cur) => acc + cur.unitPrice * cur.quantity,
          0
        )
        return totalPrice
      }

      const couponPrice = this.coupon.selected.reduce((acc, cur) => {
        const { orderPrice } = this.price
        let amount = cur.amount
        if (cur.type === 'DELIVERY' && cur.amount > this.price.deliveryFee) {
          amount = this.price.deliveryFee
        }

        if (cur.type === 'BASKET') {
          if (cur.displayCatalogIds.length === 0 && cur.displayProductIds.length === 0) {
            // catalogId, productId 해당 없을때
            if (cur.amount > orderPrice) {
              amount = orderPrice
            }
          } else if (cur.displayCatalogIds.length === 0) {
            // catalogId가 없고 productId만 해당될때
            const filteredProducts = this.$store.getters['preOrder/products'].filter(product =>
              cur.displayProductIds.includes(product.productId)
            )

            const totalPrice = getCouponFilteredPrice(filteredProducts)
            const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
            amount = saleCouponPrice
          } else if (cur.displayProductIds.length === 0) {
            // productId가 없고 catalogId만 해당 될떄
            const filteredProducts = this.$store.getters['preOrder/products'].filter(product =>
              cur.displayCatalogIds.some(id => product.catalogIds.includes(id))
            )

            const totalPrice = getCouponFilteredPrice(filteredProducts)
            const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
            amount = saleCouponPrice
          } else {
            // productId, catalogId 모두 해당될때
            const filteredProducts = this.$store.getters['preOrder/products'].filter(
              product =>
                cur.displayCatalogIds.some(id => product.catalogIds.includes(id)) ||
                cur.displayProductIds.includes(product.productId)
            )

            const totalPrice = getCouponFilteredPrice(filteredProducts)
            const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
            amount = saleCouponPrice
          }
        }

        acc += amount
        return acc
      }, 0)

      const point = this.baeminPointSpentAmount

      return couponPrice + point
    },

    deliveryCouponPrice() {
      const deliveryFee = this.coupon.selected.reduce((acc, cur) => {
        if (cur.type !== 'DELIVERY') return acc

        acc += cur.amount
        return acc
      }, 0)

      if (deliveryFee > this.price.deliveryFee) return this.price.deliveryFee

      return deliveryFee
    },

    orderCouponPrice() {
      function getCouponFilteredPrice(filteredProducts) {
        const filteredTotalitems = filteredProducts.reduce(
          (itemAcc, itemCur) => [...itemAcc, ...itemCur.items],
          []
        )
        const totalPrice = filteredTotalitems.reduce(
          (acc, cur) => acc + cur.unitPrice * cur.quantity,
          0
        )
        return totalPrice
      }

      const orderAmount = this.coupon.selected.reduce((acc, cur) => {
        if (cur.type === 'DELIVERY') return acc

        if (cur.displayCatalogIds.length === 0 && cur.displayProductIds.length === 0) {
          // catalogId, productId 해당 없을때
          acc += cur.amount
        } else if (cur.displayCatalogIds.length === 0) {
          const filteredProducts = this.$store.getters['preOrder/products'].filter(product =>
            cur.displayProductIds.includes(product.productId)
          )

          const totalPrice = getCouponFilteredPrice(filteredProducts)
          const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
          acc += saleCouponPrice
        } else if (cur.displayProductIds.length === 0) {
          const filteredProducts = this.$store.getters['preOrder/products'].filter(product =>
            cur.displayCatalogIds.some(id => product.catalogIds.includes(id))
          )

          const totalPrice = getCouponFilteredPrice(filteredProducts)
          const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
          acc += saleCouponPrice
        } else {
          const filteredProducts = this.$store.getters['preOrder/products'].filter(
            product =>
              cur.displayCatalogIds.some(id => product.catalogIds.includes(id)) ||
              cur.displayProductIds.includes(product.productId)
          )

          const totalPrice = getCouponFilteredPrice(filteredProducts)
          const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
          acc += saleCouponPrice
        }

        return acc
      }, 0)

      if (orderAmount > this.price.orderPrice) return this.price.orderPrice

      return orderAmount
    },

    baeminPointSpentAmount() {
      return this.baeminPoint.spentAmount || 0
    }

    // text() {
    //   const cartDiscountPrice = this.cartDiscount.amount
    //   const couponPrice = this.coupon.selected.reduce((acc, e) => acc + e.amount, 0)
    //   const orderPriceText = `주문금액 ${parseInt(this.price.orderPrice).toLocaleString()}원`
    //   const cartDiscountPriceText = !cartDiscountPrice
    //     ? 0
    //     : ` - 즉시할인 ${parseInt(cartDiscountPrice, 10).toLocaleString()}원`
    //   const couponPriceText = !couponPrice
    //     ? 0
    //     : ` - 할인쿠폰 ${parseInt(couponPrice, 10).toLocaleString()}원`
    //   // const deliveryPriceText = ` + 배달팁 ${this.price.deliveryFee || 0}원`
    //   let result = ''
    //   result += orderPriceText
    //   result += cartDiscountPriceText === 0 ? '' : cartDiscountPriceText
    //   result += couponPriceText === 0 ? '' : couponPriceText
    //   // result += deliveryPriceText
    //   return result
    // }
    // price() {
    //   return this.price.deliveryFee
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.payment-wrapper {
  width: 100%;
  height: auto;
  box-sizing: border-box;

  .giftcard-wrapper {
    margin-bottom: 15px;
  }
  .payment-price-wrapper {
    width: 100%;
    height: auto;

    .payment-price {
      width: 100%;
      height: auto;
      /* padding-top: 12px; */

      .text {
        line-height: 1.31;
        letter-spacing: -0.38px;
      }

      .delivery-tip-text {
        white-space: nowrap;
      }
      .delivery-tip-wrap {
        .delivery-tip-discount-number {
          margin-right: 6px;
          color: $light-gray-5;
        }
      }
    }
  }

  .payment-price-text {
    height: 60px;
    align-items: center;
    border-top: 1px solid $gray-3;
  }
}
</style>
